<template lang="pug">
	div
		toast.cajaToast(v-for="t in toasts", :key="t.id", :t="t", :top="tops[t.id]", :ref="'toast-' + t.id", :class="t.style")
</template>

<script>
import Toast from './toast'
import { mapGetters } from 'vuex'
export default {
	components: {
		toast: Toast
	},

	computed: {
		...mapGetters({
			toasts: 'toast/toasts'
		}),

		tops () {
			const tops = {}

			let alto = 60

			for (let i = 0; i < this.toasts.length; i++) {
				const t = this.toasts[i]
				tops[t.id] = {
					top: alto + 'px'
				}

				if (this.$refs['toast-' + t.id]) {
					if (this.$refs['toast-' + t.id].length > 0) {
						alto = alto + this.$refs['toast-' + t.id][0].$el.offsetHeight + 10
					}
				} else {
					alto = alto + 60
				}
			}

			return tops
		}
	}
}
</script>
<style scoped>
	toast.cajaToast {
		transition: all 200ms ease-in-out;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/toasts/wrapper.vue